module.exports = __webpack_public_path__ + "static/img/5.6b098e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncajzx/5.png
// module id = oeZJ
// module chunks = 1